import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from '@app/core/auth';

import { BaseComponent } from './layout-sidebar/base/base.component';
import { ErrorPageComponent } from './layout-sidebar/content/error-page/error-page.component';
import { EmbedReplitComponent } from './modules/embed-replit/embed-replit.component';
import { PrintLetterTemplateComponent } from './prints/print-letter-template/print-letter-template.component';
import { PrintProductComponent } from './prints/print-product/print-product.component';

//

const routes :Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'public',
    loadChildren: () =>
      import('./public/public.module').then((m) => m.PublicModule),
  },
  {
    path: 'letter',
    outlet: 'print',
    component: PrintLetterTemplateComponent,
    children: [{ path: 'product', component: PrintProductComponent }],
  },
  {
    path: '',
    component: BaseComponent,
    // canActivate: [AuthGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./modules/dashboard/dashboard.module').then(
            (m) => m.DashboardModule,
          ),
      },
      {
        path: 'inventory',
        loadChildren: () =>
          import('./modules/inventory/inventory.module').then(
            (m) => m.InventoryModule,
          ),
      },
      {
        path: 'shipping',
        loadChildren: () =>
          import('./modules/shipping/shipping.module').then(
            (m) => m.ShippingModule,
          ),
      },
      {
        path: 'channels',
        loadChildren: () =>
          import('./modules/channels/channels.module').then(
            (m) => m.ChannelsModule,
          ),
      },
      {
        path: 'product-categories',
        loadChildren: () =>
          import('./modules/product-categories/product-categories.module').then(
            (m) => m.ProductCategoriesModule,
          ),
      },
      {
        path: 'pipelines',
        loadChildren: () =>
          import('./modules/pipelines/pipelines.module').then(
            (m) => m.PipelinesModule,
          ),
      },
      {
        path: 'shipping-matrix',
        loadChildren: () =>
          import('./modules/shipping-carriers/shipping-carriers.module').then(
            (m) => m.ShippingCarriersModule,
          ),
      },
      {
        path: 'orders',
        loadChildren: () =>
          import('./modules/purchase-orders/purchase-orders.module').then(
            (m) => m.PurchaseOrdersModule,
          ),
      },
      {
        path: 'staff',
        loadChildren: () =>
          import('./modules/staff/staff.module').then((m) => m.StaffModule),
      },
      {
        path: 'locations',
        loadChildren: () =>
          import('./modules/locations/locations.module').then(
            (m) => m.LocationsModule,
          ),
      },
      {
        path: 'clients',
        loadChildren: () =>
          import('./modules/clients/clients.module').then((m) => m.ClientsModule),
      },
      {
        path: 'sales',
        loadChildren: () =>
          import('./modules/sales/sales.module').then((m) => m.SalesModule),
      },
      {
        path: 'products',
        loadChildren: () =>
          import('./modules/products/products.module').then(
            (m) => m.ProductsModule,
          ),
      },
      {
        path: 'factories',
        loadChildren: () =>
          import('./modules/factories/factories.module').then(
            (m) => m.FactoriesModule,
          ),
      },
      {
        path: 'messages',
        loadChildren: () =>
          import('./modules/messaging/messaging.module').then(
            (m) => m.MessagingModule,
          ),
      },
      {
        path: 'reports',
        loadChildren: () =>
          import('./modules/reports/reports.module').then((m) => m.ReportsModule),
      },
      {
        path: 'revenue',
        loadChildren: () =>
          import('./modules/revenue/revenue.module').then((m) => m.RevenueModule),
      },
      {
        path: 'settings',
        loadChildren: () =>
          import('./modules/settings/settings.module').then(
            (m) => m.SettingsModule,
          ),
      },
      {
        path: 'tools',
        loadChildren: () =>
          import('./modules/tools/tools.module').then((m) => m.ToolsModule),
      },
      {
        path: 'integrations',
        loadChildren: () =>
          import('./modules/integrations/integrations.module').then(
            (m) => m.IntegrationsModule,
          ),
      },
      {
        path: 'variant-types',
        loadChildren: () =>
          import('./modules/variant-types/variant-types.module').then(
            (m) => m.VariantTypesModule,
          ),
      },
      {
        path: 'product-tags',
        loadChildren: () =>
          import('./modules/product-tags/product-tags.module').then(
            (m) => m.ProductTagsModule,
          ),
      },
      {
        path: 'client-types',
        loadChildren: () =>
          import('./modules/client-types/client-types.module').then(
            (m) => m.ClientTypesModule,
          ),
      },
      {
        path: 'client-purchase-order-types',
        loadChildren: () =>
          import(
            './modules/client-purchase-order-types/client-purchase-order-types.module'
          ).then((m) => m.ClientPurchaseOrderTypesModule),
      },
      {
        path: 'units-of-measure',
        loadChildren: () =>
          import('./modules/unit-measurement/unit-measurement.module').then(
            (m) => m.UnitMeasurementModule,
          ),
      },
      {
        path: 'orders',
        loadChildren: () =>
          import('./modules/order/order.module').then((m) => m.OrderModule),
      },
      {
        path: 'pricing',
        loadChildren: () =>
          import('./modules/pricing/pricing.module').then((m) => m.PricingModule),
      },
      {
        path: 'manage',
        loadChildren: () =>
          import('./modules/manage/manage.module').then((m) => m.ManageModule),
      },
      {
        path: 'warehouse-mobile-app',
        loadChildren: () =>
          import('./modules/warehouse-mobile-app/warehouse-mobile-app.module').then(
            (m) => m.WarehouseMobileAppModule,
          ),
      },
      {
        path: 'automation-rules',
        loadChildren: () =>
          import('./modules/automation-rules/automation-rules.module').then(
            (m) => m.AutomationRulesModule,
          ),
      },
      {
        path: 'custom-fields',
        loadChildren: () =>
          import('./modules/custom-field/custom-field.module').then(
            (m) => m.CustomFieldModule,
          ),
      },
      {
        path: 'templates',
        loadComponent: () =>
          import(
            '../v2/modules/templates/components/template/template.component'
          ).then((m) => m.TemplateComponent),
        children: [
          {
            path: 'list',
            loadComponent: () =>
              import(
                '../v2/modules/templates/components/template-ag-grid/template-ag-grid.component'
              ).then((m) => m.TemplateAgGridComponent),
          },
          {
            path: 'form',
            loadComponent: () =>
              import(
                '../v2/modules/templates/components/template-form/template-form.component'
              ).then((m) => m.TemplateFormComponent),
          },
          {
            path: 'form/:id',
            loadComponent: () =>
              import(
                '../v2/modules/templates/components/template-form/template-form.component'
              ).then((m) => m.TemplateFormComponent),
          },
          {
            path: '',
            redirectTo: 'list',
            pathMatch: 'full',
          },
        ],
      },
      {
        path: 'bom',
        loadChildren: () =>
          import('./modules/bom/bom.module').then((m) => m.BomModule),
      },
      {
        path: 'assembly-orders',
        loadChildren: () =>
          import('./modules/assembly-order/assembly-order.module').then(
            (m) => m.AssemblyOrderModule,
          ),
      },
      {
        path: 'cost-layers',
        loadChildren: () =>
          import('./modules/cost-layers/cost-layers.module').then(
            (m) => m.CostLayersModule,
          ),
      },
      {
        path: 'embed-replit',
        component: EmbedReplitComponent,
        canActivate: [AuthGuard],
      },
      { path: 'error/:type', component: ErrorPageComponent },
      { path: '', redirectTo: 'inventory/skus', pathMatch: 'full' },
      { path: '**', redirectTo: 'inventory/skus', pathMatch: 'full' },
    ],
  },

  { path: '**', redirectTo: 'error/403', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
